module.exports = __webpack_public_path__ + "img/nt9-02-82-1_1.prt.30c3142c.jpg";